<template>
    <div>
        <v-row>
            <v-col>
                <v-autocomplete solo prefix="Kampagne:" v-model="$store.state.meetings.bookingCampaign" :items="$store.getters['meetings/bookingCampaigns']" />
            </v-col>
            <v-col>
                <v-autocomplete solo prefix="Mødetype:" v-model="$store.state.meetings.filters.type" :items="$store.state.meetings.types" />
            </v-col>
            <v-col v-if="route === 'meetings'">
                <v-autocomplete solo prefix="Mødestatus:" v-model="$store.state.meetings.filters.status" :items="[{ text: 'Alle', value: null }, ...$store.state.meetings.statuses]" />
            </v-col>
            <v-col v-if="route === 'meetings'">
                <v-autocomplete solo prefix="Møderesultat:" v-model="$store.state.meetings.filters.result" :items="[{ text: 'Alle', value: null }, ...$store.state.meetings.results]" />
            </v-col>
            <v-col v-if="route === 'offers'">
                <v-autocomplete solo prefix="Tilbudsstatus:" v-model="$store.state.meetings.filters.offerStatus" :items="[{ text: 'Alle', value: null }, ...$store.state.meetings.offerStatuses]" />
            </v-col>
            <v-col v-if="route === 'offers'">
                <v-autocomplete solo prefix="Tilbudsresultat:" v-model="$store.state.meetings.filters.offerResult" :items="[{ text: 'Alle', value: null }, ...$store.state.meetings.offerResults]" />
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <router-view v-else :meetings="meetings" @meetingDeleted="getData" />
    </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'debounce'

export default {
    data () {
        return {
            loading: true,
            datePicker: false,
            meetings: null
        }
    },
    computed: {
        route() {
            return this.$route.name
        },
        range () {
            return this.$store.state.meetings.range
        },
        period () {
            return this.$store.state.meetings.period
        },
        changes () {
            return this.$store.state.meetings.changes
        },
        filters () {
            return this.$store.state.meetings.filters
        },
        salesAgent () {
            return this.$store.state.meetings.salesAgent
        },
        searchString () {
            return this.$store.state.meetings.searchString
        },
        searching () {
            return this.$store.state.meetings.searchString !== null && this.$store.state.meetings.searchString.length > 0
        },
        team () {
            return this.$store.state.meetings.team
        },
        bookingCampaign () {
            return this.$store.state.meetings.bookingCampaign
        }
    },
    methods: {
        async getData () {
            if (this.$route.name === 'BookingAllCalendar') {
                this.loading = false
                return null
            }
            this.loading = true
            this.$store.state.meetings.changedMeetings = false
            let team, department
            if (this.$store.state.meetings.team === 'Alle teams') {
                team = null
            } else if (this.$store.state.meetings.team === 'tryg') {
                department = 'tryg'
            } else if (this.$store.state.meetings.team === 'alka') {
                department = 'alka'
            } else {
                team = this.$store.state.meetings.team
            }
            let response = await this.$http().get('/booking/registration/all', {
                params: {
                    team,
                    department,
                    bookingCampaign: this.$store.state.meetings.bookingCampaign,
                    type: this.$store.state.meetings.filters.type,
                    status: this.$store.state.meetings.filters.status,
                    result: this.$store.state.meetings.filters.result,
                    offerStatus: this.$store.state.meetings.filters.offerStatus,
                    offerResult: this.$store.state.meetings.filters.offerResult,
                    salesAgent: this.$store.state.meetings.salesAgent,
                    from: this.searching ? null : this.range[0],
                    to: this.searching ? null : this.range[1],
                    route: this.searching ? null : this.route,
                    searchString: this.searchString,
                }
            })
            this.meetings = response.data.meetings.map(meeting => {
                const mappedMeeting = {
                    ...meeting,
                    meetingTime: moment(meeting.meetingTime).subtract(1, 'hour').format('HH:mm')
                }
                return {
                    ...mappedMeeting
                }
            })
            this.loading = false
        }
    },
    watch: {
        filters: {
            handler () {
                this.getData()
            },
            deep: true
        },
        range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
		},
        $route: function () {
            this.$store.commit('meetings/setFilters', this.route)
            this.getData()
        },
        period: function () {
		    this.$store.commit("meetings/setRange", this.$store.state.meetings.period);
        },
        changes: function () {
            this.getData()
        },
        team: function () {
            this.getData()
        },
        salesAgent: function () {
            this.getData()
        },
		searchString: {
			handler: debounce(function () {
                if (this.searchString.length >= 3) this.getData();
            }, 1000),
			deep: true
        },
        bookingCampaign: function () {
            this.getData()
        }
    },
    created () {
        this.$store.commit('meetings/setFilters', this.route)
        if (this.searchString) {
            debounce(function () {
                if (this.searchString.length >= 3) this.getData();
            }, 1000)
        } else this.getData()
    }
}
</script>